import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom"
export default function Profile(props) {

    const { setPageName } = props

    useEffect(() => {
        setPageName("Profile")
    }, []);
    return (
        <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
            <div className='ProfileArea'>
                <Outlet />
            </div>
        </div>
    );
}
